/* eslint-disable @typescript-eslint/ban-ts-comment */
import { OrganizationStage } from 'entities-next/fundingRounds'
import { isEmpty, uniq } from 'lodash'
import { getAlpha3CodeFromLocation } from 'scenes/Dashboard/data/locations/helpers'

import { ScoutingCampaign, ScoutingCampaignParams } from '../../../../../../../../entities-next/scoutingCampaign'

type DefaultScoutingCampaignParams = Required<
  Pick<
    ScoutingCampaignParams,
    | 'internalMinimumYear'
    | 'internalMaximumYear'
    | 'internalStages'
    | 'internalLocations'
    | 'internalNegativeLocations'
    | 'packageCountable'
    | 'radarScouting'
    | 'internalIncludeCompaniesWithoutMaturityInformation'
  >
>

export function generateDefaultScoutingCampaignParams(
  scoutingCampaign?: Partial<ScoutingCampaign>
): ScoutingCampaignParams {
  const defaultScoutingCampaignData: DefaultScoutingCampaignParams = {
    internalMinimumYear: 0,
    internalMaximumYear: 0,
    internalLocations: '',
    internalNegativeLocations: '',
    internalStages: '',
    radarScouting: false,
    packageCountable: true,
    internalIncludeCompaniesWithoutMaturityInformation: false,
  }

  const internalStages: Set<string> = new Set([...(scoutingCampaign?.organizationStages?.stages ?? [])])

  if (scoutingCampaign?.organizationFoundedAt) {
    const { minimumYear, maximumYear } = scoutingCampaign.organizationFoundedAt
    defaultScoutingCampaignData.internalMinimumYear = minimumYear
    defaultScoutingCampaignData.internalMaximumYear = maximumYear
  }

  if (scoutingCampaign?.organizationStages) {
    defaultScoutingCampaignData.internalStages = uniq(scoutingCampaign?.organizationStages.stages).join(', ')
  }

  if (scoutingCampaign?.includeCompaniesWithoutMaturityInformation) {
    defaultScoutingCampaignData.internalIncludeCompaniesWithoutMaturityInformation =
      scoutingCampaign.includeCompaniesWithoutMaturityInformation
    if (!isEmpty(internalStages)) {
      internalStages.add(OrganizationStage.Series_Unknown)
    }
  }

  if (scoutingCampaign?.organizationHeadquarters) {
    defaultScoutingCampaignData.internalLocations = scoutingCampaign.organizationHeadquarters.locations
      .map((location) => getAlpha3CodeFromLocation(location))
      .join(', ')
  }

  if (scoutingCampaign?.negativeOrganizationHeadquarters) {
    defaultScoutingCampaignData.internalNegativeLocations = scoutingCampaign.negativeOrganizationHeadquarters.locations
      .map((location) => getAlpha3CodeFromLocation(location))
      .join(', ')
  }

  if (!isEmpty(internalStages)) {
    defaultScoutingCampaignData.internalStages = uniq(Array.from(internalStages)).join(', ')
  }

  return defaultScoutingCampaignData
}
